// Display names for "common items" on home – resolved to products by name from catalog
export const COMMON_ITEM_NAMES: string[] = [
  'Apple', 'Banana', 'Milk', 'Bread', 'Eggs', 'Cheese',
  'Orange', 'Water', 'Carrot', 'Cookies', 'Apple Juice', 'Cereal',
]

export const CATEGORY_LABELS: Record<string, string> = {
  Fruits: '🍎 Fruits',
  Vegetables: '🥕 Vegetables',
  Dairy: '🥛 Dairy',
  Snacks: '🍪 Snacks',
  Drinks: '🥤 Drinks',
  Pantry: '🍞 Pantry',
}

export const CATEGORIES = ['Fruits', 'Vegetables', 'Dairy', 'Snacks', 'Drinks', 'Pantry'] as const
